import { Link, useLocation } from "react-router-dom";
import { NavLink, Card, Title, useMantineColorScheme } from "@mantine/core";
import { ShieldCheck, Lock } from "lucide-react";

export function SettingsNav() {
    const location = useLocation();
    const pathname = location.pathname;
    const { colorScheme } = useMantineColorScheme();

    return (
        <Card 
            withBorder 
            padding="md" 
            radius="md" 
            shadow="sm"
            style={{
                backgroundColor: colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'var(--mantine-color-white)',
                borderColor: colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : undefined
            }}
        >
            <Card.Section withBorder inheritPadding py="xs" style={{ borderColor: colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : undefined }}>
                <Title order={5}>Security Settings</Title>
            </Card.Section>
            <Card.Section py="xs">
                <NavLink
                    component={Link}
                    to="/settings/mfa"
                    label="MFA Settings"
                    leftSection={<ShieldCheck size={16} />}
                    active={pathname === "/settings/mfa"}
                />
                <NavLink
                    component={Link}
                    to="/settings/password"
                    label="Change Password"
                    leftSection={<Lock size={16} />}
                    active={pathname === "/settings/password"}
                />
            </Card.Section>
        </Card>
    );
}
